<div class="table__container">
	<div class="table__header">
		<h2 class="table__title">
			{{ title }}
		</h2>
		<div class="header-right">
			<div class="d-flex btns-container" #btnsContainer>
				<!-- Generate Button -->
				<button
					class="btn--generate"
					nz-button
					nzType="primary"
					[disabled]="generateLoading || disableGenerate"
					(click)="showGenerateModal = true"
				>
					{{ 'common_generate' | translate }}
					<ng-container *ngIf="generateLoading">
						<i class="ml-2" nz-icon [nzType]="'loading'"></i>
					</ng-container>
				</button>

				<!-- Send Button -->
				<button
					nz-button
					nzType="default"
					class="icon-btn"
					[title]="'common_send' | translate"
					[disabled]="disableSend || !canSend"
					(click)="handleBulkSend()"
				>
					<i nz-icon nzType="mail" nzTheme="outline"></i>
				</button>

				<!-- Download Button -->
				<button
					nz-button
					nzType="default"
					class="icon-btn"
					[title]="'common_download' | translate"
					[disabled]="!canBulkDownload"
					(click)="handleBulkDownload()"
				>
					<i nz-icon nzType="download" nzTheme="outline"></i>
				</button>

				<!-- Delete Button -->
				<button
					nz-button
					nzType="default"
					class="icon-btn delete"
					[title]="'common_delete' | translate"
					[disabled]="disableDelete || !canDelete"
					(click)="handleBulkDelete()"
				>
					<i nz-icon nzType="delete" nzTheme="outline"></i>
				</button>
			</div>

			<!-- Selected count label moved inside header-right -->
			<div class="selected-count-container">
				<div
					class="selected-count-label"
					[style.visibility]="hasSelected ? 'visible' : 'hidden'"
				>
					{{ selectedCount }} {{ 'bulk_selected' | translate }}
				</div>
			</div>
		</div>
	</div>

	<div class="table__wrapper">
		<table>
			<thead>
				<tr>
					<th>
						<label
							nz-checkbox
							[(ngModel)]="selectAll"
							(ngModelChange)="toggleSelectAll()"
						></label>
					</th>
					<th>{{ 'table_head-document-respondant' | translate }}</th>
					<th>{{ 'table_head-document-state' | translate }}</th>
					<th>{{ 'table_head-document-date' | translate }}</th>
					<th>{{ 'table_head-document-total-time' | translate }}</th>
					<th>
						{{
							'table_head-document-total-time-override'
								| translate
						}}
					</th>
					<th>{{ 'table_head-document-actions' | translate }}</th>
				</tr>
			</thead>
			<tbody>
				<ng-container *ngIf="loading">
					<tr>
						<td colspan="7" class="text-center">
							<i nz-icon nzType="loading"></i>
							{{ 'common_loading' | translate }}
						</td>
					</tr>
				</ng-container>
				<ng-container *ngIf="!loading">
					<ng-container
						*ngIf="displayItems.length > 0; else noAttestationsTpl"
					>
						<tr *ngFor="let item of displayItems; let i = index">
							<!-- Checkbox -->
							<td>
								<label
									nz-checkbox
									[ngModel]="isItemSelected(item)"
									(ngModelChange)="toggleItemSelection(item)"
								></label>
							</td>

							<!-- Owner -->
							<td
								class="owner"
								[class.owner-clickable]="item.document"
								(click)="
									item.document && onReadDocument(item._id)
								"
							>
								{{ getOwnerName(item) }}
							</td>

							<!-- State -->
							<td
								class="state"
								*ngIf="item.document"
								[ngSwitch]="getDocumentStatus(item)"
							>
								<ng-container *ngSwitchCase="'created'">
									<span>{{
										'formation-intervention-state-admin-created'
											| translate
									}}</span>
								</ng-container>
								<ng-container *ngSwitchCase="'generated'">
									<span>{{
										'formation-intervention-state-admin-generated'
											| translate
									}}</span>
								</ng-container>
								<ng-container *ngSwitchCase="'sent'">
									<span>{{
										'formation-intervention-state-admin-sended'
											| translate
									}}</span>
								</ng-container>
								<ng-container *ngSwitchCase="'signed'">
									<span
										class="d-flex align-items-center justify-content-center"
									>
										<i
											nz-icon
											nzType="check-circle"
											class="mr-2"
											[style.color]="'black'"
										></i>
										<span>{{
											'formation-intervention-state-admin-signed'
												| translate
										}}</span>
									</span>
								</ng-container>
								<ng-container *ngSwitchDefault>
									<span>-</span>
								</ng-container>
							</td>
							<td class="state" *ngIf="!item.document">
								<span>-</span>
							</td>

							<!-- Date -->
							<td class="date">
								<span
									*ngIf="
										item.document && getCreatedDate(item)
									"
								>
									{{
										getCreatedDate(item)
											| date
												: 'dd MMMM yyyy'
												: ''
												: translateService.currentLang
									}}
								</span>
								<span
									*ngIf="
										!item.document || !getCreatedDate(item)
									"
									>-</span
								>
							</td>

							<!-- Total Time -->
							<td class="total-time">
								<span *ngIf="item.total_time">
									{{ item.total_time }}
								</span>
								<span *ngIf="!item.total_time">-</span>
							</td>

							<!-- Total Time Override -->
							<td class="total-time-override">
								<span *ngIf="item.total_time_override">
									{{ item.total_time_override }} ({{
										item.total_time_percent
									}}%)
								</span>
								<span
									*ngIf="
										!item.total_time_override &&
										item.total_time
									"
									>{{ item.total_time }} (100%)</span
								>
								<span
									*ngIf="
										!item.total_time_override &&
										!item.total_time
									"
									>-</span
								>
							</td>

							<!-- Actions -->
							<td>
								<div class="actions">
									<!-- Generate button for specific respondant -->
									<button
										nz-button
										nzType="default"
										class="icon-btn"
										[title]="'common_generate' | translate"
										[disabled]="
											generateLoading || disableGenerate
										"
										(click)="openRespondantModal(item)"
									>
										<i
											nz-icon
											nzType="file-add"
											nzTheme="outline"
										></i>
									</button>

									<!-- Download button -->
									<button
										nz-button
										nzType="default"
										class="icon-btn"
										[title]="'common_download' | translate"
										[disabled]="!canDownload(item)"
										(click)="
											canDownload(item) &&
												onDownloadDocument(
													item._id,
													getDocumentLabel(item)
												)
										"
									>
										<i
											nz-icon
											nzType="download"
											nzTheme="outline"
										></i>
									</button>

									<!-- Send button -->
									<button
										nz-button
										nzType="default"
										class="icon-btn"
										[title]="'common_send' | translate"
										[disabled]="
											disableSend || !canDownload(item)
										"
										(click)="
											canDownload(item) &&
												onSendDocument(item._id)
										"
									>
										<i
											nz-icon
											nzType="mail"
											nzTheme="outline"
										></i>
									</button>

									<!-- Delete button -->
									<button
										nz-button
										nzType="default"
										class="icon-btn delete"
										[title]="'common_delete' | translate"
										[disabled]="
											disableDelete || !canDownload(item)
										"
										(click)="
											canDownload(item) &&
												onDeleteDocument(item._id)
										"
									>
										<i
											nz-icon
											nzType="delete"
											nzTheme="outline"
										></i>
									</button>
								</div>
							</td>
						</tr>
					</ng-container>
				</ng-container>
			</tbody>
		</table>
	</div>
</div>

<ng-template #noAttestationsTpl>
	<tr>
		<td colspan="7" class="text-center">
			{{ 'no_attestations_found' | translate }}
		</td>
	</tr>
</ng-template>

<!-- Modal for selecting template and generating for all -->
<nz-modal
	[(nzVisible)]="showGenerateModal"
	[nzTitle]="
		hasSelected
			? ('bulk_generate_selected_title' | translate)
			: ('formation-attestation-generate-title' | translate)
	"
	(nzOnCancel)="
		showGenerateModal = false; globalTimeOverride = defaultTimeOverride
	"
	(nzOnOk)="handleBulkGenerate()"
	[nzOkLoading]="generateLoading"
>
	<ng-container>
		<div class="generate-popup">
			<div class="form-group">
				<label>{{
					'formation-attestation-template' | translate
				}}</label>
				<nz-select
					class="form-control w-100"
					[(ngModel)]="selectedTemplate"
					(ngModelChange)="onTemplateChange($event)"
				>
					<nz-option
						*ngFor="let template of templateOptions"
						[nzValue]="template"
						[nzLabel]="template | translate"
					></nz-option>
				</nz-select>
			</div>
			<div class="form-group">
				<label>{{
					'formation-attestation-total-time-override' | translate
				}}</label>
				<input
					type="number"
					class="ant-input"
					[(ngModel)]="globalTimeOverride"
					[placeholder]="defaultTimeOverride"
					min="0"
				/>
			</div>
		</div>
	</ng-container>
</nz-modal>

<!-- Modal for generating attestation for a specific respondant -->
<nz-modal
	[(nzVisible)]="showRespondantModal"
	[nzTitle]="respondantModalTitle"
	(nzOnCancel)="
		showRespondantModal = false;
		respondantTimeOverride = respondantDefaultTimeOverride
	"
	(nzOnOk)="handleRespondantGenerateSubmit()"
	[nzOkLoading]="generateLoading"
>
	<ng-container>
		<div class="generate-popup">
			<div class="form-group">
				<label>{{
					'formation-attestation-template' | translate
				}}</label>
				<br />
				<nz-select
					class="form-control w-100"
					[(ngModel)]="selectedTemplate"
					(ngModelChange)="onTemplateChange($event)"
				>
					<nz-option
						*ngFor="let template of templateOptions"
						[nzValue]="template"
						[nzLabel]="template | translate"
					></nz-option>
				</nz-select>
			</div>
			<div class="form-group">
				<label>{{
					'formation-attestation-total-time-override' | translate
				}}</label>
				<input
					type="number"
					class="ant-input"
					[(ngModel)]="respondantTimeOverride"
					[placeholder]="respondantDefaultTimeOverride"
					min="0"
				/>
			</div>
		</div>
	</ng-container>
</nz-modal>
